export class TaskType {
	public is_available;
	public is_side_activity: false;

	constructor(obj) {
		this.is_available = obj.is_available;
		this.is_side_activity = obj.is_side_activity;
	}
} 
